import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EditIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Edit",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m11.86 27.84.25-.1h.1c.08-.05.16-.11.23-.17l12.15-12.08c.28-.28.44-.65.43-1.05-.02-.84-.71-1.5-1.55-1.48-.38 0-.75.16-1.03.43L11.43 24.3l-.88-.87 10.97-10.87c.5-.66.38-1.6-.28-2.11a1.5 1.5 0 0 0-1.82 0L8.41 21.32l-.89-.87L18.54 9.56c.53-.64.45-1.59-.19-2.12a1.51 1.51 0 0 0-1.94.01L4.32 19.38c-.12.13-.21.27-.28.43v.14s.01.08 0 .13l-2.02 7.98q-.03.18 0 .36c0 .82.68 1.49 1.5 1.48.12.02.25.02.38 0l8.07-1.98-.1-.09ZM25.93 3.06a3.527 3.527 0 0 0-4.9 0L19.42 4.6c-.28.28-.44.66-.44 1.06s.16.77.44 1.05l5.87 5.8c.59.59 1.55.59 2.14 0l1.56-1.54a3.416 3.416 0 0 0 0-4.84l-3.07-3.07Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M11.52 28.03H5c-.55 0-1-.45-1-1v-6.52c0-.27.11-.52.29-.71L19.21 4.88a2.997 2.997 0 0 1 4.24 0l3.69 3.71a3.02 3.02 0 0 1 0 4.24l-14.9 14.9a1 1 0 0 1-.71.29Zm-5.52-2h5.11l14.61-14.61a.996.996 0 0 0 0-1.41L22.03 6.3a1 1 0 0 0-.71-.29c-.27 0-.52.1-.71.29L5.99 20.92v5.11Zm20.43-13.91"
      }), /*#__PURE__*/_jsx("path", {
        d: "M24.26 15.29c-.26 0-.51-.1-.71-.29l-6.52-6.52a.996.996 0 1 1 1.41-1.41l6.52 6.52a.996.996 0 0 1-.71 1.7Z"
      })]
    })
  }));
};